<app-page name="Floor manager report">
	<div *ngIf="report" class="shadow mb-3">
		<div class="row bg-gradient-primary m-0 p-3 text-light rounded-top">
			<div class="col-6">
				<h4 class="mb-0">Monthly totals per user</h4>
			</div>
			<div class="col-6 text-right">
				<form class="form-inline justify-content-end">
					<select class="form-control" [(ngModel)]="selectedMonth" [ngModelOptions]="{standalone: true}" (ngModelChange)="updateReport()">
						<option *ngFor="let month of months" [value]="month">{{month}}</option>
					</select>
					<select class="form-control ml-3" [(ngModel)]="selectedYear" [ngModelOptions]="{standalone: true}" (ngModelChange)="updateReport()">
						<option *ngFor="let year of years" [value]="year">{{year}}</option>
					</select>
				</form>
			</div>
		</div>

		<div class="p-3 text-center text-muted" *ngIf="report.items.length === 0">
			No product sales found for this month.
		</div>

		<div class="p-3" *ngIf="report.items.length > 0">
			<table class="table table-sm table-striped table-borderless text-right mb-0">
				<thead>
				<tr>
					<th class="text-left">User</th>
					<th>Qty</th>
					<th>Gross</th>
					<th>Discount</th>
					<th>Ex VAT</th>
					<th>VAT</th>
					<th>Inc VAT</th>
				</tr>
				</thead>
				<tbody>
				<tr *ngFor="let item of report.items">
					<td class="text-left">{{item.user?.name}}</td>
					<td>{{item.totalQuantity}}</td>
					<td>{{item.totalGrossAmount | currency:'EUR'}}</td>
					<td>{{item.totalDiscountAmount | currency:'EUR'}}</td>
					<td>{{item.totalExVat | currency:'EUR'}}</td>
					<td>{{item.totalVat | currency:'EUR'}}</td>
					<td><strong>{{item.totalIncVat | currency:'EUR'}}</strong></td>
				</tr>
				</tbody>
				<tfoot>
				<tr class="font-weight-bold">
					<td class="text-left">Total</td>
					<td>{{report.totals.totalQuantity}}</td>
					<td>{{report.totals.totalGrossAmount | currency:'EUR'}}</td>
					<td>{{report.totals.totalDiscountAmount | currency:'EUR'}}</td>
					<td>{{report.totals.totalExVat | currency:'EUR'}}</td>
					<td>{{report.totals.totalVat | currency:'EUR'}}</td>
					<td>{{report.totals.totalIncVat | currency:'EUR'}}</td>
				</tr>
				</tfoot>
			</table>
		</div>
	</div>
</app-page>
